import { CustomQuestionsFieldErrors } from '@/core/validation/field-errors';

export function validateShortAnswer(field) {
  if (!Array.isArray(field?.questionValue?.responses)) {
    return CustomQuestionsFieldErrors.QuestionValueTypeError;
  }
  if (
    field.questionValue.isRequired &&
    field.questionValue.responses.length === 0
  ) {
    return CustomQuestionsFieldErrors.EmptyResponse;
  }
  if (
    field.questionValue.isRequired &&
    !field.questionValue?.responses[0]?.answer
  ) {
    return CustomQuestionsFieldErrors.EmptyResponse;
  }
  return '';
}

export function validateYesNoAnswer(field) {
  if (!Array.isArray(field?.questionValue?.responses)) {
    return CustomQuestionsFieldErrors.QuestionValueTypeError;
  }
  if (
    field.questionValue.isRequired &&
    !field.questionValue?.responses[0]?.answer
  ) {
    return CustomQuestionsFieldErrors.EmptyChoiceResponse;
  }
  return '';
}

function validateMultipleChoiceSingleAnswer(field) {
  if (!field.questionValue.responses[0].answer) {
    return CustomQuestionsFieldErrors.EmptyChoiceResponse;
  }
  return '';
}

export function validateMultipleChoice(field) {
  if (!field.questionValue.isRequired) {
    return '';
  }
  if (!Array.isArray(field?.questionValue?.responses)) {
    return CustomQuestionsFieldErrors.QuestionValueTypeError;
  }
  if (field.questionValue.responses.length === 0) {
    return CustomQuestionsFieldErrors.EmptyChoiceResponse;
  }

  if (field.questionValue.responses.length === 1) {
    return validateMultipleChoiceSingleAnswer(field);
  }
  // Potentially we could add multiple choice with multiple selection here.
}

export function validateAdditionalQuestions(field) {
  switch (field.questionValue.type) {
    case 'SHORT':
      return validateShortAnswer(field);
    case 'MULTIPLE':
      return validateMultipleChoice(field);
    case 'YES_NO':
      return validateYesNoAnswer(field);
  }
  return '';
}
